<script setup>
defineProps({
  legend: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: null,
  },
  info: {
    type: String,
    default: null,
  },
  grid: {
    type: String,
    default: 'flex flex-col sm:grid sm:grid-cols-2 md:grid-cols-4 gap-0 sm:gap-4',
  },
})
</script>

<template>
  <Fieldset :legend>
    <template #legend>
      <div class="inline-flex items-center gap-2">
        <span>{{ legend }}</span>
        <InfoPopover :info />
      </div>
    </template>
    <div class="flex flex-col gap-6 p-2 md:p-4">
      <div v-if="description" class="text-surface-500 text-sm">
        {{ description }}
      </div>
      <div :class="grid">
        <slot />
      </div>
    </div>
  </Fieldset>
</template>
